var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsCounter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5326 0C44.1866 0 50 5.40683 50 13.453V36.547C50 44.6635 44.3655 49.9422 35.6455 49.9925L14.4701 50C5.81613 50 0 44.5932 0 36.547V13.453C0 5.334 5.63446 0.0577599 14.3545 0.0100452L35.5299 0H35.5326ZM35.5326 3.76695L14.3683 3.777C7.96036 3.81215 4.12882 7.42843 4.12882 13.453V36.547C4.12882 42.6118 7.99615 46.233 14.4674 46.233L35.6317 46.2255C42.0396 46.1904 45.8712 42.5691 45.8712 36.547V13.453C45.8712 7.38825 42.0066 3.76695 35.5326 3.76695ZM35.0017 33.8365C36.1412 33.8365 37.0661 34.6803 37.0661 35.72C37.0661 36.7597 36.1412 37.6035 35.0017 37.6035H15.1283C13.9887 37.6035 13.0639 36.7597 13.0639 35.72C13.0639 34.6803 13.9887 33.8365 15.1283 33.8365H35.0017ZM35.0017 23.323C36.1412 23.323 37.0661 24.1667 37.0661 25.2064C37.0661 26.2461 36.1412 27.0899 35.0017 27.0899H15.1283C13.9887 27.0899 13.0639 26.2461 13.0639 25.2064C13.0639 24.1667 13.9887 23.323 15.1283 23.323H35.0017ZM22.7107 12.8338C23.8503 12.8338 24.7751 13.6775 24.7751 14.7172C24.7751 15.7569 23.8503 16.6007 22.7107 16.6007H15.1274C13.9879 16.6007 13.063 15.7569 13.063 14.7172C13.063 13.6775 13.9879 12.8338 15.1274 12.8338H22.7107Z",
    fill: "#00BAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsCounter2);
export default __webpack_public_path__ + "static/media/about-us-counter-2.28a936c324b8f6ae981c6ce638789548.svg";
export { ForwardRef as ReactComponent };